// Pre-built rights bundles creators can apply with one click.
// Matches RIGHTS_TYPES in filters.js.

export const DEAL_TEMPLATES = [
    {
        key: "full_copyright",
        name: "Full Copyright (Worldwide)",
        description: "Outright, perpetual, worldwide transfer of all rights. The most common Silver Screen Xchange deal.",
        rights_type: ["Full Copyright Ownership"],
        exclusivity: "Exclusive",
    },
    {
        key: "svod_remake",
        name: "Global SVOD + Remake Rights",
        description: "Streaming exploitation worldwide plus exclusive remake adaptation rights. Copyright stays with creator.",
        rights_type: ["Streaming Rights", "Remake Rights"],
        exclusivity: "Exclusive",
    },
    {
        key: "territorial_bundle",
        name: "Territorial Distribution Bundle",
        description: "Distribution rights for a defined territory. Good for regional theatrical + TV deals.",
        rights_type: ["Territorial Rights", "Distribution Rights"],
        exclusivity: "Exclusive",
    },
    {
        key: "remake_only",
        name: "Remake Rights Only",
        description: "License the story & format for remake production in any language or country.",
        rights_type: ["Remake Rights"],
        exclusivity: "Exclusive",
    },
    {
        key: "adaptation",
        name: "Book / Series Adaptation",
        description: "Rights to adapt the film's underlying IP into a series, novel or stage play.",
        rights_type: ["Adaptation Rights"],
        exclusivity: "Non-exclusive",
    },
    {
        key: "a1",
        name: "A1 Rights Only",
        description: "Premium theatrical first-release rights in a given market.",
        rights_type: ["A1 Rights"],
        exclusivity: "Exclusive",
    },
];
